import { ModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";

export interface ModalNodeDefinition extends Omit<ModalNode, "next" | "prev" | "toObject"> {
	hasNext: boolean;
	hasPrev: boolean;
}

export class ModalNode {
	public definition: ModalDefinition;
	public next: ModalNode | null = null;
	public prev: ModalNode | null = null;
	public index: number;

	constructor(definition: ModalDefinition, index = 0) {
		this.definition = definition;
		this.index = index;
	}

	toObject = (): ModalNodeDefinition => ({
		hasNext: !!this.next,
		hasPrev: !!this.prev,
		definition: this.definition,
		index: this.prev?.index ? this.prev?.index + 1 : 0
	});
}
